/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import type { UniversalCreateButtonCombinedProps } from '../../../types';

import { UniversalCreateButton } from './LazyTrigger';

/**
 * @deprecated Import ` { UniversalCreateButton }` from `@atlassian/universal-create` instead.
 *
 * @example
 * ```tsx
 * import { UniversalCreateButton } from '@atlassian/universal-create';
 * ```
 */
export function UniversalCreateButtonLazy(props: UniversalCreateButtonCombinedProps) {
	return <UniversalCreateButton {...props} />;
}
